import { useMemo } from 'react';
import { useAuth } from '../../AuthProvider';
import { PERMISSIONS } from '../PermissionConstants';

export default function usePermissions() {

    const { additionalUserInfo } = useAuth();

    const userAvailablePermissions = useMemo(() => {

        const permissions = [
            ...(additionalUserInfo?.permissionIds || []),
            ...(additionalUserInfo?.permissionSetIds || []),
        ];

        return new Set(permissions);

    }, [additionalUserInfo]);

    const hasPermission = (permission) =>
        
        userAvailablePermissions.has(permission);

    const hasAnyPermission = (...permissions) =>
        
        
        permissions.some(permission => userAvailablePermissions.has(permission));

    const hasAllPermissions = (...permissions) =>
        
        permissions.every(permission => userAvailablePermissions.has(permission));

    return {

        permissions: userAvailablePermissions,

        hasPermission,
        hasAnyPermission,
        hasAllPermissions,

        canManageEmployeeAccess:
            hasPermission(PERMISSIONS.USER_ACCESS_EDIT),
        

        canViewEmployees:
            hasPermission(PERMISSIONS.EMPLOYEE_VIEW),

        canEditEmployees:
            hasPermission(PERMISSIONS.EMPLOYEE_EDIT),

        canViewPayroll:
            hasPermission(PERMISSIONS.PAYROLL_VIEW),

        canEditPayroll:
            hasPermission(PERMISSIONS.PAYROLL_EDIT),

        canRunPayroll:
            hasPermission(PERMISSIONS.PAYROLL_RUN),

        canExportPayroll:
            hasPermission(PERMISSIONS.PAYROLL_EXPORT),

        canApproveLeave:
            hasPermission(PERMISSIONS.LEAVE_APPROVE),

        canCreateLeave:
            hasPermission(PERMISSIONS.LEAVE_CREATE),

        canViewJobs:
            hasPermission(PERMISSIONS.JOB_VIEW),

        canEditJobs:
            hasPermission(PERMISSIONS.JOB_EDIT),

        canEditRoster:
            hasPermission(PERMISSIONS.ROSTER_EDIT),

        canViewProfile:
            hasPermission(PERMISSIONS.PROFILE_VIEW),

        canSubmitTimesheet:
            hasPermission(PERMISSIONS.TIMESHEET_SUBMIT),
    };
}